declare namespace $ {

	export class $mol_icon_telegram extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=telegram.view.tree.d.ts.map